/**
 * ? @description : Delete Modal for Mapped Tab
 */

// Dependencies
import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useDispatch } from "react-redux";

// Axios Component
import Axios from "../../../../../axios/Axios";

// Redux Component
import { showSnackbar } from "../../../../redux/features/appSlice";

function MappedModalDelete(props) {
  // * Redux
  const dispatch = useDispatch();

  // * Store Id Value of Selected Row Data
  const id = props.tabledata[0];

  // ? Delete Method : Remove Selected Row Data from the Server
  const deleteMappedPair = async () => {
    try {
      let options = {
        method: "delete",
        url: `/mapping/${id}`,
        auth: true,
        data: null,
      };

      const response = await Axios(
        options.method,
        options.url,
        options.auth,
        options.data
      );

      if (response.status === 200) {
        props.onHide();
        props.onCloseCallback();
        // window.location.reload();
        dispatch(
          showSnackbar({
            message: "Mapped pair deleted successfully",
            severity: "success",
          })
        );
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: "Unable to delete the pair. Please try again later.",
          severity: "error",
        })
      );
    }
  };

  return (
    props.tabledata.length > 0 && (
      <Modal
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        size="lg"
        centered
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            <h5>Confirmation</h5>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* <h6>Selected Map Id&nbsp;:&nbsp;{props.tabledata[0]}</h6> */}
          <h4>Are you sure You'd like to unmap this profile ?</h4>
        </Modal.Body>

        <Modal.Footer>
          <Button type="button" variant="light" onClick={props.onHide}>
            CANCEL
          </Button>
          <Button type="submit" onClick={deleteMappedPair}>
            YES
          </Button>
        </Modal.Footer>
      </Modal>
    )
  );
}

export default MappedModalDelete;
